import { BaseService } from "./base.service";
import { RoleDto, CreateRoleDto, UpdateRoleDto } from "../types/dtos/role-privilege.dto";
import { ENDPOINTS } from "../endpoints";
import { CustomResponseEntity } from "../types/common";
import { api } from "../client/axiosClient";

export class RoleService extends BaseService<RoleDto, CreateRoleDto, UpdateRoleDto> {
  constructor() {
    super(ENDPOINTS.roles.base());
  }

  async findByOrganization(organizationId: string): Promise<CustomResponseEntity<RoleDto[]>> {
    return api.get(ENDPOINTS.roles.byOrganization(organizationId));
  }
}

export const roleService = new RoleService();
